import * as TypeGraphQL from "type-graphql";
export var TradeStatus;
(function (TradeStatus) {
    TradeStatus["PENDING"] = "PENDING";
    TradeStatus["OPEN"] = "OPEN";
    TradeStatus["PARTIAL"] = "PARTIAL";
    TradeStatus["COMPLETED"] = "COMPLETED";
    TradeStatus["CANCELED"] = "CANCELED";
})(TradeStatus || (TradeStatus = {}));
TypeGraphQL.registerEnumType(TradeStatus, {
    name: "TradeStatus",
    description: undefined,
});
//# sourceMappingURL=TradeStatus.js.map